import { passCodes } from '../passCodes';

const hints = [
    {
        text: 'Vypište si písmena, která máte stejná jak v textu hádanky tak na tabulce pod sochou Ježíše. Z nich vám pak vyjde zpráva.',
    },
    {
        text: 'Kódem je: tvrz',
        solution: true,
    },
];
export const step36graveyard = {
    id: 34,
    title: '16. stanoviště',
    cipher: {
        label: 'Úkol',
        text: `
            <p class="font-weight-bold">
                Využijte věci v okolí a dešifrujte tento text:
            </p>
            <div class="zdar-cipher-graveyard-box">
                a ti wěřící, jejíž čisté svědomí, čistější je nebes záře, čiňte víc an bůh jasti ve nás radosten, staňm ať z zwídavosti ba věri
            </div>
            <p>
                Nejde o to co je v textech odlišné, ale co zůstalo stejné, každé písmeno je ve výsledném kódu použito pouze jednou.
            </p>
            <p>Písmena je potřeba seřadit, aby vám vyšel kód. Poradíme vám, kód začíná na: Jděte...</p>
        `,
    },
    catImage: 7,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[26],
    additionalInfo: 'Odpovědí je směr kam se máte vydat.',
    hints: hints,
    snowHints: hints,
};
